import {memo} from 'react'
import cn from 'clsx'
import {Pie} from '@ant-design/plots'

import styles from './DrawdownsChart.module.scss'
import {COLOR, CHART_THEME} from 'common/constants'

interface DrawdownsChartProps {
  className?: string
  size?: number
  project: any
}

function DrawdownsChart({className, size = 160, project}: DrawdownsChartProps) {
  const {withdrawn, withdrawPending, facilityLimit1} = project
  const hasData = Boolean(withdrawn || withdrawPending || facilityLimit1)
  const data = hasData
    ? [
        {
          type: 'withdrawal',
          value: withdrawn,
        },
        {
          type: 'pending',
          value: withdrawPending,
        },
        {
          type: 'loan',
          value: facilityLimit1 - (withdrawn + withdrawPending),
        },
      ]
    : null

  const config: any = {
    ...options,
    data,
    width: size,
    height: size,
  }

  return (
    <div
      className={cn(styles.root, className)}
      style={hasData ? undefined : {width: size, height: size}}
    >
      {hasData && <Pie {...config} />}
    </div>
  )
}

export default memo(DrawdownsChart)

const options = {
  theme: CHART_THEME,
  autoFit: false,
  legend: false,
  tooltip: false,
  angleField: 'value',
  colorField: 'type',
  color: [COLOR.cyan, COLOR.whiteV2, COLOR.whiteV2],
  radius: 0.995,
  label: {
    autoRotate: false,
    type: 'inner',
    offset: '-50%',
    content: ({type, percent}: any) => {
      // console.log(percent)
      if (type === 'withdrawal') return `${(percent * 100).toFixed(1)}%`
    },
    style: {
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center',
    },
  },
  pieStyle: (value: any) => ({
    stroke:
      value.type === 'withdrawal'
        ? COLOR.cyan
        : value.type === 'loan'
        ? COLOR.whiteV2
        : undefined,
  }),
  pattern: ({type}: any) => {
    if (type === 'pending') {
      return {
        type: 'dot',
        cfg: {
          size: 3,
          padding: 2,
          fill: COLOR.charcoal,
          fillOpacity: 1,
        },
      }
    }
  },
}
